// ═══════════════════════════════════════════════════════════════════════════
// PAGE PROJECTS — fragments de la modale d'édition (rendu pur)
// Extrait de page-projects.ts (découpe god-function `showProjectModal` 2026-07) :
// builder d'onglet PUR (aucun état de closure — les Sets de pilotes mutables
// restent dans la modale). Comportement identique à l'inline. L'onglet Comités
// et le style des onglets, communs à la modale programme, sont dans `pilots-form`
// (audit dette 2026-09-13, D4b).
// ═══════════════════════════════════════════════════════════════════════════
//
// Bare refs utilisées (résolues via core-globals.d.ts) : esc, t.

import type { StageRow, RiskListRow } from './page-projects.js';

const buildStageOptions = (stages: ReadonlyArray<StageRow>, currentStage: string): string =>
  stages
    .map(
      (s) =>
        `<option value="${esc(s.name)}" ${s.name === currentStage ? 'selected' : ''}>${esc(s.name)}</option>`,
    )
    .join('');

const buildRiskListOptions = (
  riskLists: ReadonlyArray<RiskListRow>,
  riskListId: number | string,
): string =>
  riskLists
    .map(
      (l) =>
        `<option value="${l.id}" ${l.id === riskListId ? 'selected' : ''}>${esc(l.name)}</option>`,
    )
    .join('');

/** Onglet « Général » de la modale projet (code, nom, phase, liste de risques). */
export function buildProjectGeneralTab(
  code: string,
  name: string,
  currentStage: string,
  stages: ReadonlyArray<StageRow>,
  riskListId: number | string,
  riskLists: ReadonlyArray<RiskListRow>,
  isNew: boolean,
): string {
  const stageOpts = buildStageOptions(stages, currentStage);
  const listOpts = buildRiskListOptions(riskLists, riskListId);
  return `
    <div class="form-row">
      <div class="form-group" style="flex:0 0 100px"><label>${esc(t('pageProjects.field.code'))}</label>
        <input type="text" id="pm-code" class="text-mono w-full" maxlength="5" value="${esc(code)}"
          placeholder="${esc(t('pageProjects.field.codePlaceholder'))}" style="text-transform:uppercase"></div>
      <div class="form-group flex-1"><label>${esc(t('pageProjects.field.name'))}</label>
        <input type="text" id="pm-name" value="${esc(name)}" placeholder="${esc(t('pageProjects.field.namePlaceholder'))}" required></div>
    </div>
    <div class="form-row mt-3">
      <div class="form-group"><label>${esc(t('pageProjects.field.stage'))}</label>
        <select id="pm-stage"><option value="">—</option>${stageOpts}</select></div>
      <div class="form-group"><label>${esc(t('pageProjects.field.riskList'))}</label>
        <select id="pm-risklist"><option value="">${esc(t('pageProjects.field.riskListNone'))}</option>${listOpts}</select>
        ${isNew ? `<small class="text-muted">${esc(t('pageProjects.field.riskListNote'))}</small>` : ''}
      </div>
    </div>`;
}
